import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { InteditComponent } from './intedit.component';

const routes: Routes = [
  { path: '', component: InteditComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class InteditRoutingModule { }
